/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `nächte`
};

const en_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `nights`
};

const es_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `noches`
};

const fr_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `nuits`
};

const it_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `notti`
};

const nl_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `nætter`
};

const pt_date_range_picker__night_count_placeholder__other = /** @type {(inputs: {}) => string} */ () => {
	return `noites`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__night_count_placeholder__other(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__night_count_placeholder__other", locale)
	if (locale === "de") return de_date_range_picker__night_count_placeholder__other(inputs)
	if (locale === "en") return en_date_range_picker__night_count_placeholder__other(inputs)
	if (locale === "es") return es_date_range_picker__night_count_placeholder__other(inputs)
	if (locale === "fr") return fr_date_range_picker__night_count_placeholder__other(inputs)
	if (locale === "it") return it_date_range_picker__night_count_placeholder__other(inputs)
	if (locale === "nl") return nl_date_range_picker__night_count_placeholder__other(inputs)
	return pt_date_range_picker__night_count_placeholder__other(inputs)
};